import { useState, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Panel } from 'components/ideal-core-ui'
import { FaBell } from 'react-icons/fa'
import * as ACT from '../actions'
import DatePicker from 'react-datepicker'
import isEmpty from 'lodash/isEmpty'
import { getUser } from 'utils/authService'
import { getNotificationTime } from '../helpers'
import { toEmailPreferences } from '../serializers'
import { makePutRequest } from 'utils/api'
import { PUSH_NOTIFICATION } from 'actions/actionTypes'
import s from './DailyNotificationEmail.scss'

const DailyNotificationEmail = () => {
  const dispatch = useDispatch()

  const [emailsOn, setEmailsOn] = useState(true)
  const [time, setTime] = useState(null)

  const user = useSelector(state => state.admin.profile)

  useEffect(() => {
    const { id } = getUser()
    dispatch({ type: ACT.GET_USER_FETCH_REQUESTED, payload: { id } })
  }, [dispatch])

  useEffect(() => {
    if (!isEmpty(user)) {
      setTime(getNotificationTime(user.preferences?.notificationTime))
      setEmailsOn(user.preferences?.dailyNotification ?? false)
    }
  }, [user])

  const updateEmailsPreferences = async (emailsChecked, date) => {
    setEmailsOn(emailsChecked)
    date && setTime(date)

    try {
      await makePutRequest(`/v1/users/${user.id}`, toEmailPreferences(emailsChecked, date || time))
      dispatch({
        type: PUSH_NOTIFICATION,
        payload: {
          title: 'Email Preferences updated successfuly',
          level: 'success'
        }
      })
    } catch (e) {
      dispatch({
        type: PUSH_NOTIFICATION,
        payload: {
          title: 'An error occurred. Please contact support',
          level: 'error'
        }
      })
    }
  }

  return (
    <Panel
      title="Daily Notification Email"
      titleIcon={<FaBell />}
      innerStyles={{ minHeight: 'auto' }}
      panelStyles={{ marginTop: 24 }}
      hasInnerPadding
    >
      <div className={s.container}>
        <p className={s.infoText}>
          Turn the daily notification email on and set the time you want to receive it in your
          Inbox. This notification email will list items that are due that day, such as: opportunity
          bids, follow-up, tasks, proposals, events, proposals that need to be reviewed by you that
          day, and proposals that need to be sent out that day.
        </p>
        <div className={s.inputContainer}>
          <input
            type="radio"
            checked={emailsOn}
            onChange={() => {
              setEmailsOn(true)
            }}
            className={s.radioBtn}
          />{' '}
          On
        </div>
        <div className={s.inputContainer}>
          <input
            type="radio"
            checked={!emailsOn}
            onChange={() => {
              updateEmailsPreferences(false)
            }}
            className={s.radioBtn}
          />{' '}
          Off
        </div>
        {emailsOn && (
          <div className={s.timePickerWrapper}>
            <span className={s.timeInfo}>Receive daily at: </span>
            <DatePicker
              selected={time}
              onChange={date => {
                updateEmailsPreferences(true, date)
              }}
              popperPlacement="top"
              showTimeSelect
              showTimeSelectOnly
              timeIntervals={15}
              timeCaption="Time"
              dateFormat="h:mm aa"
              className={s.timePicker}
            />
          </div>
        )}
      </div>
    </Panel>
  )
}

export default DailyNotificationEmail
